import { render, staticRenderFns } from "./fullscreen-editor.vue?vue&type=template&id=2aa23fb7&scoped=true&"
import script from "./fullscreen-editor.vue?vue&type=script&lang=js&"
export * from "./fullscreen-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa23fb7",
  null
  
)

export default component.exports